import React from 'react';
import { Container, Box, Typography, Card, CardContent, CardMedia } from '@mui/material';
import instruc from '../assets/instruc.png';
import interactive from '../assets/interactive.png';
import support from '../assets/support.png';

const features = [
  { title: 'Expert Instructors', description: 'Learn from professionals.', img: instruc },
  { title: 'Interactive Content', description: 'Engaging quizzes and assignments.', img: interactive },
  { title: 'Community Support', description: 'Join a community of learners.', img: support },
];

const FeaturesSection = () => {
  return (
    <Container sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        Why Choose Us?
      </Typography>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
        {features.map((feature, index) => (
          <Box gridColumn={{ xs: 'span 12', sm: 'span 6', md: 'span 4' }} key={index}>
            <Card>
              <CardMedia component="img" height="200" image={feature.img} alt={feature.title} />
              <CardContent>
                <Typography variant="h5" component="div">
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default FeaturesSection;
